/* eslint-disable react/prop-types */
import React from "react";
import { CustomImportRemote } from "./CustomImportRemote.js";
function System(props) {
  const {
    system,
    system: {
      url,
      scope,
      module,
      remoteEntryFileName
    },
    fallback,
    appProps
  } = props;
  const Component = React.useMemo(() => {
    return /*#__PURE__*/React.lazy(() => CustomImportRemote({
      url,
      scope,
      module,
      remoteEntryFileName
    }));
  }, [module, remoteEntryFileName, scope, url]);
  if (!system || !url || !scope || !module || !remoteEntryFileName) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, fallback);
  }
  return /*#__PURE__*/React.createElement(React.Suspense, {
    fallback: fallback
  }, /*#__PURE__*/React.createElement(Component, appProps));
}
export default System;